module.exports = __webpack_public_path__ + "static/img/hover6.00de5a57.png";